// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Noto Sans KR', 'Roboto', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0A1929;
  color: #FFFFFF;
}

code {
  font-family: 'Roboto Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* 스크롤바 스타일링 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #0A1929;
}

::-webkit-scrollbar-thumb {
  background: #173A5E;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: #16C79A;
}

/* 전역 애니메이션 */
@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.pulse-animation {
  animation: pulse 1.5s infinite ease-in-out;
}

/* 전역 트랜지션 */
.page-transition-enter {
  opacity: 0;
  transform: translateY(10px);
}

.page-transition-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms, transform 300ms;
}

.page-transition-exit {
  opacity: 1;
  transform: translateY(0);
}

.page-transition-exit-active {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 300ms, transform 300ms;
}

/* 반응형 유틸리티 클래스 */
.mobile-only {
  display: none;
}

@media (max-width: 600px) {
  .mobile-only {
    display: block;
  }
  
  .desktop-only {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mEAAmE;EACnE,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8FAA8F;AAChG;;AAEA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Noto Sans KR', 'Roboto', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0A1929;\n  color: #FFFFFF;\n}\n\ncode {\n  font-family: 'Roboto Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* 스크롤바 스타일링 */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0A1929;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #173A5E;\n  border-radius: 8px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #16C79A;\n}\n\n/* 전역 애니메이션 */\n@keyframes pulse {\n  0% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n.pulse-animation {\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n/* 전역 트랜지션 */\n.page-transition-enter {\n  opacity: 0;\n  transform: translateY(10px);\n}\n\n.page-transition-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n\n.page-transition-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.page-transition-exit-active {\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: opacity 300ms, transform 300ms;\n}\n\n/* 반응형 유틸리티 클래스 */\n.mobile-only {\n  display: none;\n}\n\n@media (max-width: 600px) {\n  .mobile-only {\n    display: block;\n  }\n  \n  .desktop-only {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
